/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
import '../../../common/time';
import '../instruments/models';
import '../../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "servicing": {
            "nested": {
              "activities": {
                "nested": {
                  "models": {
                    "nested": {
                      "Activity": {
                        "fields": {
                          "planId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "type": {
                            "type": ".squareup.capital.servicing.activities.models.Activity.Type",
                            "id": 3,
                            "rule": "optional"
                          },
                          "status": {
                            "type": ".squareup.capital.servicing.activities.models.Activity.Status",
                            "id": 4,
                            "rule": "optional"
                          },
                          "initiatedAt": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "effectiveAt": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "remainingBalanceMoney": {
                            "type": ".squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "previousBalanceMoney": {
                            "type": ".squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "sortKey": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "splitPaymentDetails": {
                            "type": ".squareup.capital.servicing.activities.models.SplitPaymentDetails",
                            "id": 11,
                            "rule": "optional"
                          },
                          "holdRatePayment": {
                            "type": ".squareup.capital.servicing.activities.models.HoldRatePaymentDetail",
                            "id": 1001
                          },
                          "manualPayment": {
                            "type": ".squareup.capital.servicing.activities.models.ManualPaymentDetail",
                            "id": 1002
                          },
                          "autoPayment": {
                            "type": ".squareup.capital.servicing.activities.models.AutoPaymentDetail",
                            "id": 1003
                          },
                          "scheduledPayment": {
                            "type": ".squareup.capital.servicing.activities.models.ScheduledPaymentDetail",
                            "id": 1004
                          },
                          "planCancel": {
                            "type": ".squareup.capital.servicing.activities.models.PlanCancelDetail",
                            "id": 1005
                          },
                          "planDeposit": {
                            "type": ".squareup.capital.servicing.activities.models.PlanDepositDetail",
                            "id": 1006
                          },
                          "serviceCredit": {
                            "type": ".squareup.capital.servicing.activities.models.ServiceCreditDetail",
                            "id": 1007
                          },
                          "lateFee": {
                            "type": ".squareup.capital.servicing.activities.models.LateFeeDetail",
                            "id": 1008
                          },
                          "paymentFromPlan": {
                            "type": ".squareup.capital.servicing.activities.models.PaymentFromPlanDetail",
                            "id": 1009
                          },
                          "renewCancel": {
                            "type": ".squareup.capital.servicing.activities.models.RenewCancelDetail",
                            "id": 1010
                          },
                          "scraFeeCredit": {
                            "type": ".squareup.capital.servicing.activities.models.ScraFeeCreditDetail",
                            "id": 1011
                          },
                          "paymentRefund": {
                            "type": ".squareup.capital.servicing.activities.models.PaymentRefundDetail",
                            "id": 1012
                          },
                          "transferIn": {
                            "type": ".squareup.capital.servicing.activities.models.TransferInDetail",
                            "id": 1013
                          },
                          "transferOut": {
                            "type": ".squareup.capital.servicing.activities.models.TransferOutDetail",
                            "id": 1014
                          },
                          "unknownPayment": {
                            "type": ".squareup.capital.servicing.activities.models.UnknownPaymentDetail",
                            "id": 1015
                          },
                          "interestAccrual": {
                            "type": ".squareup.capital.servicing.activities.models.InterestAccrualDetail",
                            "id": 1016
                          },
                          "forgiveness": {
                            "type": ".squareup.capital.servicing.activities.models.ForgivenessDetail",
                            "id": 1017
                          },
                          "eidlReduction": {
                            "type": ".squareup.capital.servicing.activities.models.EidlReductionDetail",
                            "id": 1018
                          },
                          "overpaymentRefund": {
                            "type": ".squareup.capital.servicing.activities.models.OverpaymentRefundDetail",
                            "id": 1019
                          },
                          "undoForgiveness": {
                            "type": ".squareup.capital.servicing.activities.models.UndoForgivenessDetail",
                            "id": 1020
                          },
                          "reverseServiceCredit": {
                            "type": ".squareup.capital.servicing.activities.models.ReverseServiceCreditDetail",
                            "id": 1021
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "AT_DO_NOT_USE": 0,
                              "HOLD_RATE_PAYMENT": 1,
                              "MANUAL_PAYMENT": 2,
                              "AUTO_PAYMENT": 3,
                              "SCHEDULED_PAYMENT": 4,
                              "PLAN_CANCEL": 5,
                              "PLAN_DEPOSIT": 6,
                              "SERVICE_CREDIT": 7,
                              "LATE_FEE": 8,
                              "PAYMENT_FROM_PLAN": 9,
                              "RENEW_CANCEL": 10,
                              "SCRA_FEE_CREDIT": 11,
                              "PAYMENT_REFUND": 12,
                              "TRANSFER_IN": 13,
                              "TRANSFER_OUT": 14,
                              "UNKNOWN_PAYMENT": 15,
                              "INTEREST_ACCRUAL": 16,
                              "FORGIVENESS": 17,
                              "EIDL_REDUCTION": 18,
                              "OVERPAYMENT_REFUND": 19,
                              "UNDO_FORGIVENESS": 20,
                              "REVERSE_SERVICE_CREDIT": 21
                            }
                          },
                          "Status": {
                            "values": {
                              "AS_DO_NOT_USE": 0,
                              "SUCCESSFUL": 1,
                              "PENDING": 2,
                              "FAILED": 3
                            }
                          },
                          "detail": {
                            "oneof": ["holdRatePayment", "manualPayment", "autoPayment", "scheduledPayment", "planCancel", "planDeposit", "serviceCredit", "lateFee", "paymentFromPlan", "renewCancel", "scraFeeCredit", "paymentRefund", "transferIn", "transferOut", "unknownPayment", "interestAccrual", "forgiveness", "eidlReduction", "overpaymentRefund", "undoForgiveness", "reverseServiceCredit"]
                          }
                        }
                      },
                      "SplitPaymentDetails": {
                        "fields": {
                          "totalPaymentAmountMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "legMechanism": {
                            "type": ".squareup.capital.servicing.activities.models.SplitPaymentDetails.LegMechanism",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "LegMechanism": {
                            "values": {
                              "ALM_DO_NOT_USE": 0,
                              "BANKC_SQ_CHECKING": 1,
                              "BANKC_STORED_BALANCE": 2,
                              "TELLER": 3
                            }
                          }
                        }
                      },
                      "HoldRatePaymentDetail": {
                        "fields": {
                          "paymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "dailySalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "holdRateBps": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "windowStartedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 4,
                            "rule": "optional"
                          },
                          "windowEndedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "ManualPaymentDetail": {
                        "fields": {
                          "paymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "AutoPaymentDetail": {
                        "fields": {
                          "paymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ScheduledPaymentDetail": {
                        "fields": {
                          "paymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "paymentBankAccountSummary": {
                            "type": ".squareup.capital.servicing.instruments.models.BankAccountSummary",
                            "id": 2
                          }
                        },
                        "nested": {
                          "payment_account_summary": {
                            "oneof": ["paymentBankAccountSummary"]
                          }
                        }
                      },
                      "PlanCancelDetail": {
                        "fields": {
                          "cancelMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "feeForgivenMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cancelledInterestMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "PlanDepositDetail": {
                        "fields": {
                          "depositMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "financedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "feeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "mpoPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "previousPlanIsLoan": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "eidlPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "loanDepositLocation": {
                            "type": ".squareup.capital.common.LoanDepositLocation",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": "LINKED_BANK_ACCOUNT"
                            }
                          },
                          "depositBankAccountSummary": {
                            "type": ".squareup.capital.servicing.instruments.models.BankAccountSummary",
                            "id": 7
                          }
                        },
                        "nested": {
                          "deposit_account_summary": {
                            "oneof": ["depositBankAccountSummary"]
                          }
                        }
                      },
                      "ServiceCreditDetail": {
                        "fields": {
                          "creditMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ReverseServiceCreditDetail": {
                        "fields": {
                          "reverseCreditMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "LateFeeDetail": {
                        "fields": {
                          "feeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pastDueMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "feeBps": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "PaymentFromPlanDetail": {
                        "fields": {
                          "paymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "planCreatedAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "isLoan": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "RenewCancelDetail": {
                        "fields": {
                          "cancelMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "didReopenOldPlan": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ScraFeeCreditDetail": {
                        "fields": {
                          "feeForgivenMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "refundedFeeForgivenMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "adjustedMinimumPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "PaymentRefundDetail": {
                        "fields": {
                          "paymentRefundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "dailySalesRefundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "holdRateBps": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "TransferInDetail": {
                        "fields": {
                          "transferInMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "TransferOutDetail": {
                        "fields": {
                          "transferOutMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "UnknownPaymentDetail": {
                        "fields": {
                          "paymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "InterestAccrualDetail": {
                        "fields": {
                          "interestAccrualMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accruedFor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ForgivenessDetail": {
                        "fields": {
                          "forgivenessMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "principalForgivenMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "interestForgivenMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "refundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "netForgivenessMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "eidlAdvanceMoney": {
                            "type": ".squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "sbaReportedEidlAdvanceMoney": {
                            "type": ".squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "refundBankAccountSummary": {
                            "type": ".squareup.capital.servicing.instruments.models.BankAccountSummary",
                            "id": 5
                          }
                        },
                        "nested": {
                          "refund_account_summary": {
                            "oneof": ["refundBankAccountSummary"]
                          }
                        }
                      },
                      "EidlReductionDetail": {
                        "fields": {
                          "adjustedPrincipalMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "adjustedInterestMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "payerRefundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "totalAdjustedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "OverpaymentRefundDetail": {
                        "fields": {
                          "refundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "refundBankAccountSummary": {
                            "type": ".squareup.capital.servicing.instruments.models.BankAccountSummary",
                            "id": 2
                          }
                        },
                        "nested": {
                          "refund_account_summary": {
                            "oneof": ["refundBankAccountSummary"]
                          }
                        }
                      },
                      "UndoForgivenessDetail": {
                        "fields": {
                          "reversalMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.Activity && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.Activity?.nested?.Type && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.Activity?.nested?.Status && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.SplitPaymentDetails && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.SplitPaymentDetails?.nested?.LegMechanism && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.HoldRatePaymentDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.ManualPaymentDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.AutoPaymentDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.ScheduledPaymentDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.PlanCancelDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.PlanDepositDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.ServiceCreditDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.ReverseServiceCreditDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.LateFeeDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.PaymentFromPlanDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.RenewCancelDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.ScraFeeCreditDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.PaymentRefundDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.TransferInDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.TransferOutDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.UnknownPaymentDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.InterestAccrualDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.ForgivenessDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.EidlReductionDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.OverpaymentRefundDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.activities?.nested?.models?.nested?.UndoForgivenessDetail) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Activity @ squareup/capital/servicing/activities/models.proto at 10:1
 */
export const Activity = $root.lookupType('squareup.capital.servicing.activities.models.Activity');
fixType(Activity);
Builder.createAndAttachToType(Activity);
/**
 * SOURCE Type @ squareup/capital/servicing/activities/models.proto at 11:3
 */
Activity.Type = $root.lookupEnum('squareup.capital.servicing.activities.models.Activity.Type').values;
/**
 * SOURCE Status @ squareup/capital/servicing/activities/models.proto at 90:3
 */
Activity.Status = $root.lookupEnum('squareup.capital.servicing.activities.models.Activity.Status').values;
/**
 * SOURCE SplitPaymentDetails @ squareup/capital/servicing/activities/models.proto at 151:1
 */
export const SplitPaymentDetails = $root.lookupType('squareup.capital.servicing.activities.models.SplitPaymentDetails');
fixType(SplitPaymentDetails);
Builder.createAndAttachToType(SplitPaymentDetails);
/**
 * SOURCE LegMechanism @ squareup/capital/servicing/activities/models.proto at 152:3
 */
SplitPaymentDetails.LegMechanism = $root.lookupEnum('squareup.capital.servicing.activities.models.SplitPaymentDetails.LegMechanism').values;
/**
 * SOURCE HoldRatePaymentDetail @ squareup/capital/servicing/activities/models.proto at 163:1
 */
export const HoldRatePaymentDetail = $root.lookupType('squareup.capital.servicing.activities.models.HoldRatePaymentDetail');
fixType(HoldRatePaymentDetail);
Builder.createAndAttachToType(HoldRatePaymentDetail);
/**
 * SOURCE ManualPaymentDetail @ squareup/capital/servicing/activities/models.proto at 177:1
 */
export const ManualPaymentDetail = $root.lookupType('squareup.capital.servicing.activities.models.ManualPaymentDetail');
fixType(ManualPaymentDetail);
Builder.createAndAttachToType(ManualPaymentDetail);
/**
 * SOURCE AutoPaymentDetail @ squareup/capital/servicing/activities/models.proto at 181:1
 */
export const AutoPaymentDetail = $root.lookupType('squareup.capital.servicing.activities.models.AutoPaymentDetail');
fixType(AutoPaymentDetail);
Builder.createAndAttachToType(AutoPaymentDetail);
/**
 * SOURCE ScheduledPaymentDetail @ squareup/capital/servicing/activities/models.proto at 185:1
 */
export const ScheduledPaymentDetail = $root.lookupType('squareup.capital.servicing.activities.models.ScheduledPaymentDetail');
fixType(ScheduledPaymentDetail);
Builder.createAndAttachToType(ScheduledPaymentDetail);
/**
 * SOURCE PlanCancelDetail @ squareup/capital/servicing/activities/models.proto at 194:1
 */
export const PlanCancelDetail = $root.lookupType('squareup.capital.servicing.activities.models.PlanCancelDetail');
fixType(PlanCancelDetail);
Builder.createAndAttachToType(PlanCancelDetail);
/**
 * SOURCE PlanDepositDetail @ squareup/capital/servicing/activities/models.proto at 201:1
 */
export const PlanDepositDetail = $root.lookupType('squareup.capital.servicing.activities.models.PlanDepositDetail');
fixType(PlanDepositDetail);
Builder.createAndAttachToType(PlanDepositDetail);
/**
 * SOURCE ServiceCreditDetail @ squareup/capital/servicing/activities/models.proto at 223:1
 */
export const ServiceCreditDetail = $root.lookupType('squareup.capital.servicing.activities.models.ServiceCreditDetail');
fixType(ServiceCreditDetail);
Builder.createAndAttachToType(ServiceCreditDetail);
/**
 * SOURCE ReverseServiceCreditDetail @ squareup/capital/servicing/activities/models.proto at 227:1
 */
export const ReverseServiceCreditDetail = $root.lookupType('squareup.capital.servicing.activities.models.ReverseServiceCreditDetail');
fixType(ReverseServiceCreditDetail);
Builder.createAndAttachToType(ReverseServiceCreditDetail);
/**
 * SOURCE LateFeeDetail @ squareup/capital/servicing/activities/models.proto at 231:1
 */
export const LateFeeDetail = $root.lookupType('squareup.capital.servicing.activities.models.LateFeeDetail');
fixType(LateFeeDetail);
Builder.createAndAttachToType(LateFeeDetail);
/**
 * SOURCE PaymentFromPlanDetail @ squareup/capital/servicing/activities/models.proto at 237:1
 */
export const PaymentFromPlanDetail = $root.lookupType('squareup.capital.servicing.activities.models.PaymentFromPlanDetail');
fixType(PaymentFromPlanDetail);
Builder.createAndAttachToType(PaymentFromPlanDetail);
/**
 * SOURCE RenewCancelDetail @ squareup/capital/servicing/activities/models.proto at 246:1
 */
export const RenewCancelDetail = $root.lookupType('squareup.capital.servicing.activities.models.RenewCancelDetail');
fixType(RenewCancelDetail);
Builder.createAndAttachToType(RenewCancelDetail);
/**
 * SOURCE ScraFeeCreditDetail @ squareup/capital/servicing/activities/models.proto at 257:1
 */
export const ScraFeeCreditDetail = $root.lookupType('squareup.capital.servicing.activities.models.ScraFeeCreditDetail');
fixType(ScraFeeCreditDetail);
Builder.createAndAttachToType(ScraFeeCreditDetail);
/**
 * SOURCE PaymentRefundDetail @ squareup/capital/servicing/activities/models.proto at 268:1
 */
export const PaymentRefundDetail = $root.lookupType('squareup.capital.servicing.activities.models.PaymentRefundDetail');
fixType(PaymentRefundDetail);
Builder.createAndAttachToType(PaymentRefundDetail);
/**
 * SOURCE TransferInDetail @ squareup/capital/servicing/activities/models.proto at 280:1
 */
export const TransferInDetail = $root.lookupType('squareup.capital.servicing.activities.models.TransferInDetail');
fixType(TransferInDetail);
Builder.createAndAttachToType(TransferInDetail);
/**
 * SOURCE TransferOutDetail @ squareup/capital/servicing/activities/models.proto at 284:1
 */
export const TransferOutDetail = $root.lookupType('squareup.capital.servicing.activities.models.TransferOutDetail');
fixType(TransferOutDetail);
Builder.createAndAttachToType(TransferOutDetail);
/**
 * SOURCE UnknownPaymentDetail @ squareup/capital/servicing/activities/models.proto at 288:1
 */
export const UnknownPaymentDetail = $root.lookupType('squareup.capital.servicing.activities.models.UnknownPaymentDetail');
fixType(UnknownPaymentDetail);
Builder.createAndAttachToType(UnknownPaymentDetail);
/**
 * SOURCE InterestAccrualDetail @ squareup/capital/servicing/activities/models.proto at 292:1
 */
export const InterestAccrualDetail = $root.lookupType('squareup.capital.servicing.activities.models.InterestAccrualDetail');
fixType(InterestAccrualDetail);
Builder.createAndAttachToType(InterestAccrualDetail);
/**
 * SOURCE ForgivenessDetail @ squareup/capital/servicing/activities/models.proto at 299:1
 */
export const ForgivenessDetail = $root.lookupType('squareup.capital.servicing.activities.models.ForgivenessDetail');
fixType(ForgivenessDetail);
Builder.createAndAttachToType(ForgivenessDetail);
/**
 * SOURCE EidlReductionDetail @ squareup/capital/servicing/activities/models.proto at 327:1
 */
export const EidlReductionDetail = $root.lookupType('squareup.capital.servicing.activities.models.EidlReductionDetail');
fixType(EidlReductionDetail);
Builder.createAndAttachToType(EidlReductionDetail);
/**
 * SOURCE OverpaymentRefundDetail @ squareup/capital/servicing/activities/models.proto at 341:1
 */
export const OverpaymentRefundDetail = $root.lookupType('squareup.capital.servicing.activities.models.OverpaymentRefundDetail');
fixType(OverpaymentRefundDetail);
Builder.createAndAttachToType(OverpaymentRefundDetail);
/**
 * Details about undoing/reversing a loan forgiveness.
 *
 * SOURCE UndoForgivenessDetail @ squareup/capital/servicing/activities/models.proto at 351:1
 */
export const UndoForgivenessDetail = $root.lookupType('squareup.capital.servicing.activities.models.UndoForgivenessDetail');
fixType(UndoForgivenessDetail);
Builder.createAndAttachToType(UndoForgivenessDetail);